import { Link } from 'react-router-dom'
import { __ } from 'src/libs/utilities'
import { ICardProjectProps } from '../../data/interfaces'
import getProjectLink from '../../data/utils/getProjectLink'
import { useOwnerPartner, useUserOwner } from '../../hooks/project'
import HoneycombsLabel from './HoneycombsLabel'
import MemberRatingDisplay from './MemberRatingDisplay'
import TrackLabel from './TrackLabel'

const SimpleStrokeProject = ( props: ICardProjectProps ): JSX.Element => {  
  const isOwner: boolean = useUserOwner( props.item )
  const isPartner:boolean = useOwnerPartner(props.item)
  const url = getProjectLink(props.item.id)

  return <div className="ml-2 w-100 grey2 position-relative overflow-hidden stroke-a-dark"> 
    <Link to={url} className="row hover" data-testid="project-simple-stroke-cont">  
      <div  className="col-lg-4 col-10 d-flex  py-2 align-items-center" >  
        <div className="px-4"  data-testid="project-simple-stroke-order">{ props.item.order } </div>  
        <div>
          <h6  className={`display-7 m-0 flex-grow-100 text-center text-lg-left ${!props.item.is_verified ? "opacity_5" : ""}`}  data-testid="project-simple-stroke-title">
            { props.item.title }
          </h6>     
          <div className="text-danger title" data-testid="project-simple-stroke-prize">{props.item.prize}</div>  
          <div className="text-danger text-uppercase small" data-testid="project-simple-stroke-nomination">{props.item.nomination}</div>  
        </div>       
                          
      </div> 
      <div  className="col-lg-1 col-2 d-flex flex-column justify-content-center align-items-center align-items-lg-left px-3" >            
        <MemberRatingDisplay 
          correct_member_rate={props.item.correctMemberRate}
          countedRating={props.item.r2}
          className={"text-dark "}
        />         
      </div> 
      <div  className="col-lg-3 col-12  d-flex flex-column justify-content-center  px-3" >            
        <div  className="text-overflow"> 
          <TrackLabel 
            track={props.item.track} 
            className="small d-flex my-2 ml-2 text-center text-lg-left align-items-center  text-force-contrast "
          />
        </div>     
      </div> 
      <div  className="col-lg-2 col-12  d-flex flex-column justify-content-center  px-3" >            
        <div>  <HoneycombsLabel honeycombs={props.item.honeycombs}  className=" d-md-inline my-2 ml-2 text-center text-lg-left"/> </div>      
      </div> 
      <div  className="col-lg-2 col-12 d-flex flex-column justify-content-center" >            
      {
        isOwner
          ?
          <div className="mine-label-stroke" data-testid="project-simple-stroke-my-project-label">
              { __( "My project" ) }
          </div>
          :                    
          isPartner 
              ?
              <div className="mine-label-stroke bg-success"  data-testid="project-simple-stroke-my-honeycombs-label">
                  {__("My honeycombs")}
              </div>
              :
              null
      } 
      {
        props.isMineHoneycoms
          ?
          <div className="mine-honeycombs-label-stroke"  data-testid="project-simple-stroke-my-honeycombs-label">
            { __( "My honeycombs" ) }
          </div>
          :
          null
      }         
      </div> 
    </Link> 
  </div>
}

SimpleStrokeProject.propTypes = {}

export default SimpleStrokeProject